import ready from './ready'

window['ready'] = ready
